@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "../../utils/mixins/mixins.scss";

$pt-icon-svg-inactive-color: var(--color-foreground-de-emp) !important;
$pt-icon-svg-active-color: var(--color-foreground-highlight) !important;
$pt-icon-svg-bg-color: var(--color-background) !important;

:host {
    display: inline-block;
}

.portal-custom-icon {
    width: var(--icon-size);
    height: var(--icon-size);
    display: block;

    .portal-svg {
        width: var(--icon-size);
        height: var(--icon-size);
    }

    .error-svg {
        fill: var(--color-error-icon);
    }

    .success-svg {
        fill: var(--color-success-icon);
    }

    .info-svg {
        fill: var(--color-info-icon);
    }

    .warning-svg {
        fill: var(--color-warning-icon);
    }

    .picker-svg-fill {
        fill: var(--color-icon-default);
    }

    .picker-svg-stroke {
        stroke: var(--color-icon-default);
    }

    .waffle-svg {
        fill: var(--color-foreground-de-emp);
    }

    .burger-svg {
        fill: var(--color-foreground-de-emp);
    }

    .serviceIcon {
        @include style-svg(var(--icon-color), $pt-icon-svg-bg-color, var(--icon-size));
    }
}
